import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSprayingDevice = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 20,
	viewBox: "0 0 60.0 20.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 35.0 0.0 L 35.0 10.0 M 10.0 20.0 L 35.0 10.0 L 60.0 20.0 M 25.0 20.0 L 35.0 10.0 L 45.0 20.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgSprayingDevice;
